import { render, staticRenderFns } from "./ui-label.vue?vue&type=template&id=0b83c7c6&scoped=true&"
import script from "./ui-label.vue?vue&type=script&lang=ts&"
export * from "./ui-label.vue?vue&type=script&lang=ts&"
import style0 from "./ui-label.vue?vue&type=style&index=0&id=0b83c7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83c7c6",
  null
  
)

export default component.exports